import type { CatalogTree } from '../types';

// The System tabs (admin panel screens §3.10): jobs, dead letters, webhook failures, alerts, the
// audit log and the Operators.
export const system = {
  title: 'Sistem',
  tabsLabel: 'Sistem sekmeleri',
  tabs: {
    jobs: 'İş kuyruğu',
    'dead-letters': 'Başarısız işler',
    'webhook-failures': 'Webhook hataları',
    alerts: 'Uyarılar',
    audit: 'Denetim kaydı',
    operators: 'Operatörler',
  },
  filters: {
    label: 'Filtreler',
    all: 'Tümü',
    state: 'Durum',
    type: 'Tür',
    merchantId: 'İşletme kimliği',
    orderingKey: 'Sıralama anahtarı',
    sourceKind: 'Kaynak',
    adapterId: 'Adaptör',
    verification: 'Doğrulama',
    status: 'Durum',
    source: 'Kaynak modül',
    actorKind: 'Aktör türü',
    actorId: 'Aktör kimliği',
    actionPrefix: 'İşlem',
    targetKind: 'Hedef türü',
    targetId: 'Hedef kimliği',
    supportSessionId: 'Destek oturumu',
    since: 'Başlangıç tarihi',
    until: 'Bitiş tarihi',
  },
  jobs: {
    stats: 'Kuyruk özeti',
    oldest: 'En eski bekleyen',
    oldestNone: 'Yok',
    oldestLate: 'Bir dakikadan uzun süredir bekliyor',
    dead: 'Ölü iş',
    byType: 'Türe göre',
    list: 'İşler',
    empty: 'Bu filtreye uyan iş yok.',
    attempts: '{attempt} / {max}',
    columns: {
      id: 'İş',
      type: 'Tür',
      available: 'Bekliyor',
      running: 'Çalışıyor',
      retryable: 'Yeniden denenecek',
      dead: 'Ölü',
      state: 'Durum',
      merchant: 'İşletme',
      orderingKey: 'Sıralama anahtarı',
      attempt: 'Deneme',
      runAt: 'Çalışma zamanı',
      createdAt: 'Oluşturuldu',
      finishedAt: 'Bitti',
      replayedBy: 'Yeniden çalıştıran',
    },
  },
  deadLetters: {
    list: 'Başarısız işler',
    empty: 'Başarısız iş yok.',
    replayed: 'Yeniden çalıştırıldı',
    sheetTitle: 'Başarısız iş',
    payload: 'Yük',
    error: 'Son hata',
    traceId: 'İz kimliği',
    alertLink: 'Uyarıyı göster',
    replay: 'Yeniden çalıştır',
    replayTitle: 'İş yeniden çalıştırılsın mı?',
    replayText:
      "İşin bir kopyası aynı sıralama anahtarıyla yeniden kuyruğa alınır; özgün kayıt 'yeniden çalıştırıldı' olarak işaretlenir.",
    replayedToast: 'İş yeniden kuyruğa alındı.',
    showJobs: 'İşleri göster',
    delete: 'Sil',
    deleteTitle: 'İş silinsin mi?',
    deleteText: 'İş ve yükü kalıcı olarak silinir.',
    deletedToast: 'İş silindi.',
    columns: {
      attempts: 'Deneme',
      error: 'Son hata',
      diedAt: 'Öldüğü an',
    },
  },
  webhooks: {
    list: 'Webhook hataları',
    empty: 'Webhook hatası yok.',
    hint: 'İmzası doğrulanamayan teslimat yeniden işlenemez.',
    replay: 'Yeniden işle',
    replayTitle: 'Teslimat yeniden işlensin mi?',
    replayText:
      'Teslimat yeniden kuyruğa alınır ve olayları tekrar işlenir; tekrarlar dış kimlikle ayıklanır.',
    replayedToast: 'Teslimat yeniden kuyruğa alındı.',
    source: { channel: 'Kanal', store: 'Mağaza', billing: 'Ödeme', invoicing: 'Fatura' },
    connection: 'Entegrasyonlar',
    columns: {
      id: 'Teslimat',
      source: 'Kaynak',
      adapter: 'Adaptör',
      connection: 'Mağaza bağlantısı',
      receivedAt: 'Alındı',
      verification: 'Doğrulama',
      status: 'Durum',
      attempts: 'Deneme',
    },
  },
  alerts: {
    list: 'Uyarılar',
    empty: 'Açık uyarı yok.',
    acknowledgedNote: 'Görülen bir uyarı aynı nedenle yeniden oluşursa yeni bir uyarı açılır.',
    acknowledge: 'Görüldü',
    open: 'Açık',
    seen: 'Görüldü',
    kind: {
      dead_letter: 'Ölü iş',
      webhook_verification_failed_repeated: 'Tekrarlayan imza hatası',
      send_invalid_request: 'Geçersiz gönderim',
      connection_error: 'Bağlantı hatası',
      sync_failed: 'Eşitleme hatası',
      sync_parse_error: 'Eşleme hatası',
      billing_unmatched_event: 'Eşleşmeyen ödeme olayı',
      invoice_error: 'Fatura hatası',
      evaluation_regression: 'Değerlendirme gerilemesi',
      adapter_version_mismatch: 'Adaptör sürüm uyuşmazlığı',
    },
    columns: {
      kind: 'Tür',
      source: 'Kaynak',
      merchant: 'İşletme',
      count: 'Sayı',
      firstSeen: 'İlk görülme',
      lastSeen: 'Son görülme',
      detail: 'Ayrıntı',
      acknowledgedBy: 'Gören',
      acknowledgedAt: 'Görülme zamanı',
    },
  },
  audit: {
    list: 'Denetim kaydı',
    empty: 'Bu filtreye uyan kayıt yok.',
    hint: 'Denetim kayıtları değiştirilemez ve silinemez.',
    system: 'Sistem',
    copy: 'İz kimliğini kopyala',
    copied: 'İz kimliği kopyalandı.',
    sheetTitle: 'Denetim kaydı',
    details: 'Ayrıntılar',
    actorKind: { merchant_user: 'İşletme kullanıcısı', operator: 'Operatör', system: 'Sistem' },
    columns: {
      at: 'Zaman',
      actor: 'Aktör',
      action: 'İşlem',
      target: 'Hedef',
      merchant: 'İşletme',
      reason: 'Gerekçe',
      supportSession: 'Destek oturumu',
      traceId: 'İz kimliği',
    },
  },
  operators: {
    list: 'Operatörler',
    create: 'Yeni operatör',
    createTitle: 'Yeni operatör',
    editTitle: 'Operatörü düzenle',
    setupNote: 'Kurulum bağlantısı e-posta ile gönderilir ve 60 dakika geçerlidir.',
    invite: 'Davet et',
    save: 'Kaydet',
    name: 'Ad',
    email: 'E-posta',
    role: 'Rol',
    status: 'Durum',
    statusActive: 'Etkin; kapatılırsa operatör giriş yapamaz.',
    resetTotp: 'TOTP sıfırla',
    resetTotpTitle: 'TOTP sıfırlansın mı?',
    resetTotpText:
      'Gizli anahtar ve kurtarma kodları silinir; bir sonraki girişte yeniden kayıt yapılır.',
    resetTotpDone: 'TOTP sıfırlandı.',
    disableTitle: 'Operatör devre dışı bırakılsın mı?',
    disableText: 'Operatörün oturumları kapatılır ve giriş yapamaz.',
    disable: 'Devre dışı bırak',
    saved: 'Operatör kaydedildi.',
    created: 'Davet gönderildi.',
    statusLabel: { invited: 'Davetli', active: 'Aktif', disabled: 'Devre dışı' },
    totp: { yes: 'Kayıtlı', no: 'Kayıtsız' },
    columns: {
      name: 'Ad',
      email: 'E-posta',
      role: 'Rol',
      status: 'Durum',
      totp: 'TOTP',
      lastLogin: 'Son giriş',
      createdAt: 'Oluşturuldu',
    },
  },
} as const satisfies CatalogTree;
